/**
 * Brand mark (admin variant of web/src/components/navigation/BrandMark.tsx).
 *
 * Same restrained glyph + wordmark as the customer dashboard, labeled "Admin"
 * so operators always know which surface they are on.
 */
import { ShieldAlert } from '@/components/icons';
import { cn } from '@/lib/utils';

export function BrandMark({
  className,
  withWordmark = true,
}: {
  className?: string;
  withWordmark?: boolean;
}) {
  return (
    <span className={cn('inline-flex items-center gap-2', className)}>
      <span className="flex h-7 w-7 items-center justify-center rounded-md bg-primary text-primary-foreground">
        <ShieldAlert className="h-4 w-4" />
      </span>
      {withWordmark ? (
        <span className="text-sm font-semibold tracking-tight text-foreground">
          SignupRisk <span className="text-muted-foreground">— Admin</span>
        </span>
      ) : null}
    </span>
  );
}
